<template>
  <div class='feedback_detail'>
    <div class=line-height></div>
    <div class='detail'>
      <div class='title'>
        <div class='linkman'>
          <span>{{data.linkman}}</span>
          <span>{{data.mobile_phone}}</span>
        </div>
        <div class='time'>
          {{data.create_time}}
        </div>
      </div>
      <div class='text'>
        {{data.content}}
      </div>
      <div class='images'>
        <div class='image' v-for='(item, index) in data.image_path' :key='item'>
          <img :src='item' @click="preview(index)">
        </div>
      </div>
    </div>
    <div class='reply' v-if='replyData.id'>
      <div class='content'>
        <div class='title'>
          <div class='linkman'>
            后台回复
          </div>
          <div class='time'>
            {{replyData.create_time}}
          </div>
        </div>
        <div class='text'>
          {{replyData.content}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'FeedbackDetail',
  data () {
    return {
      id: 0,
      data: {},
      replyData: {}
    }
  },
  methods: {
    getBaseInfo () {
      let vm = this
      vm.id = vm.$route.query.id
      axios.post('/wechat.php/Feedback/getFeedbackDetail', {
        user_id: localStorage.user_id,
        id: vm.id
      }).then(function (res) {
        res = res.data
        if (res.code === 1) {
          vm.data = res.data.my_feedback
          vm.replyData = res.data.replay
        } else {
          alert(res.message)
        }
      })
    },
    preview (index) {
      let obj = {
        url: this.data.image_path[index],
        urls: this.data.image_path
      }
      this.$wx.previewImage(obj)
    }
  },
  mounted () {
    this.getBaseInfo()
  }
}
</script>

<style lang="stylus">
  @import '~@styles/mixins.styl'
  @import '~@styles/varibles.styl'
  .feedback_detail
    background #fff
    .detail
      padding .2rem 4%
      .title
        .linkman
          line-height .5rem
          span:nth-child(1)
            padding-right .5rem
        .time
          line-height .4rem
          color $darkGrayColor
          font-size .28rem
      .text
        padding-top .2rem
        color $lightBlackColor
        font-size .3rem
        line-height .4rem
        padding-bottom .2rem
      .images
        width 100%
        overflow hidden
        .image
          float left
          width 25%
          padding .05rem
          box-sizing border-box
          margin 0 auto
          overflow hidden
          img
            display block
            width 82px
            height 82px
    .reply
      padding .2rem 4%
      .content
        background $bgColor
        padding .2rem 3%
        .title
          .linkman
            line-height .4rem
          .time
            line-height .4rem
            color $darkGrayColor
            font-size .28rem
        .text
          padding-top .2rem
          font-size .3rem
          line-height .4rem
          padding-bottom .2rem
</style>



// WEBPACK FOOTER //
// src/pages/feedback/Detail.vue